// this will get the initialData and parse it, for add, edit, for all three cases

import React from "react";
import SeriesForm from "./Series/SeriesForm";
import VideoForm from "./Video/VideoForm";
import AssessmentForm from "./Assessment/AssessmentForm";
import { Box, Button } from "@mui/material";
import GoBack from "../GoBack";
import { useHistory, useLocation } from "react-router-dom";
import CreateElementContextProvider, {
  useCreateElementContext,
} from "./Context/CreateElementContext";

const Form = () => {
  const { element_type } = useCreateElementContext();

  const getForm = () => {
    switch (element_type) {
      case "COMMUNICATION_TYPE_VIDEO":
        return <VideoForm />;
      case "ASSESSMENT":
        return <AssessmentForm />;
      case "SERIES":
        return <SeriesForm />;
    }
  };

  return (
    <Box flexDirection={"column"} display={"flex"} gap={4}>
      <Box display={"flex"} justifyContent={"space-between"}>
        <GoBack title={"Go Back"} />
      </Box>
      {getForm()}
    </Box>
  );
};

const FormWrapper = ({ initialData, edit, elementType, options }) => (
  <CreateElementContextProvider
    initialData={initialData}
    edit={edit}
    elementType={elementType}
    options={options}
  >
    <Form />
  </CreateElementContextProvider>
);

export default FormWrapper;
